// services/usuarioEspecialistaService.js
import api from './api';

const usuarioEspecialistaService = {
  // Obtener todas las asignaciones
  getAsignaciones: async () => {
    return await api.get('/usuarios-especialistas');
  },
  
  // Obtener internos disponibles
  getInternosDisponibles: async () => {
    return await api.get('/usuarios-especialistas/internos-disponibles');
  },
  
  // Asignar interno a especialista
  asignarInterno: async (data) => {
    return await api.post('/usuarios-especialistas', data);
  },
  
  // Eliminar asignación
  eliminarAsignacion: async (id) => {
    return await api.delete(`/usuarios-especialistas/${id}`);
  },
  
  // Obtener especialistas por interno
  getEspecialistasPorInterno: async (usuarioId) => {
    return await api.get(`/usuarios-especialistas/por-interno/${usuarioId}`);
  }
};

export default usuarioEspecialistaService;